import { useState, useEffect, useCallback } from 'react';
import { Hospital, StatusCounts, FilterState } from '../types';
import { fetchHospitals, getHospitalStats } from '../../../Http/Index';

const ITEMS_PER_PAGE = 10;

export const useHospitalData = () => {
  const [hospitals, setHospitals] = useState<Hospital[]>([]);
  const [filters, setFilters] = useState<FilterState>({ status: 'all', search: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [statusCounts, setStatusCounts] = useState<StatusCounts>({
    formatted: 0,
    matched: 0,
    doubtful: 0,
    newHospital: 0,
    approved: 0,
    rejected: 0,
    total: 0
  });

  const loadHospitals = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchHospitals({
        page: currentPage,
        limit: ITEMS_PER_PAGE,
        status: filters.status,
        search: filters.search,
        jobId: filters.jobId
      });
      setHospitals(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Failed to load hospitals:', error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, filters.status, filters.search, filters.jobId]);

  const loadStats = useCallback(async () => {
    try {
      const response = await getHospitalStats(filters.jobId);
      setStatusCounts(response.data);
    } catch (error) {
      console.error('Failed to load stats:', error);
    }
  }, [filters.jobId]);

  useEffect(() => {
    loadHospitals();
  }, [loadHospitals]);

  useEffect(() => {
    loadStats();
  }, [loadStats]);

  return {
    hospitals,
    filters,
    currentPage,
    totalPages,
    loading,
    statusCounts,
    setFilters,
    setCurrentPage,
    loadHospitals,
    loadStats
  };
};